import axios from "axios";
import qs from 'qs'
import moment from 'moment';

export default {
  namespaced: true,
  state: {
    formData: {
      ownerName: '',
      companyName: '',
      companyTitle: '',
      companyType: 'Individual',
      kepAddress: '',
      companyMail: '',
      accountName: '',
      bankName: '',
      iban: '',
      authorizedPerson: '',
      authorizedPersonMail: '',
      authorizedPersonTitle: '',
      companyAddress: '',
      subscriptionType: 'PLUS',
      coffeeSizeType: [],
      milkType: [],
      taxPlate: null,
      certificateOfActivity: null,
      signatureCircular: null,
      tradeRegistryRecord: null
    },
    merchantList: [],
    merchantDetails: {},
    loading: false,
  },
  mutations: {
    updateFormData(state, data) {
      state.formData = { ...state.formData, ...data };
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setMerchantList(state, value) {
      state.merchantList = value;
    },
    setMerchantDetails(state, value) {
      state.merchantDetails = value;
    }
  },
  actions: {
    saveFormData({ commit }, payload) {
      commit('updateFormData', payload);
    },
    fetchBankNameByIban({ commit }, iban) {
      const formData = new FormData();
      formData.append('iban', iban)
      return axios
        .post(`/api/panel/company-application/bank-info`, formData, {
          headers: { "Content-Type": "multipart/form-data" },

        }
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
    postApplyMerchantForm({ state }) {
      if (state.formData.phoneNumber) {
        state.formData.phoneNumber = state.formData.phoneNumber.replaceAll(' ', '').substring(5)
      }
      return axios
        .post(`/api/panel/company-application/new-application`, state.formData)
        .then(() => {
          alert('Başarıyla gönderildi.')
          return true;
        })
        .catch((err) => {
          const message = err.response.data.friendlyMessage.message
          if (message === "application_already_exists") {
            alert('Bu email ile başvurunuz mevcuttur.')
          }
          return false;
        });
    },
    putApplyMerchantForm({ state }, propData) {
      const formData = new FormData();
      const data = propData ? propData : state.merchantDetails;

      Object.keys(data).forEach((key) => {
        console.log(key, data[key]);

        if (key.toLowerCase().endsWith('url')) return;
        if (data[key] == 'null') return;
        if (data[key]) {
          if (key === "milkType" || key === "coffeeSizeType") {
            if (Array.isArray(data[key]) && data[key].length)
              data[key].forEach((value) => formData.append(key, value));
            return;
          }
          formData.append(key, data[key]);

        }
      });

      return axios
        .put(`/api/panel/company-application`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          const res = err.response;
          if (res.data && res.data.errors && res.data.errors.length) {
            const errors = res.data.errors;
            if (errors['TaxIdNumber'])
              if (errors['TaxIdNumber'].contains('tax_number_length')) {
                alert('Vergi Numarası 10 haneden oluşmalıdır.')
              }
          }
          else {
            alert('Bir hata oluştu')

          }
        });
    },
    getMerchantApplications({ commit }, filters) {
      commit("setLoading", true);
      const statusFilterItems = {
        'NewApplication': 'Yeni Başvuru',
        'PendingPreApproval': 'Ön Başvuru Onay Bekliyor',
        'PreApproved': 'Ön Başvuru Onaylandı',
        'PendingApproval': 'Başvuru Onay Bekliyor',
        'AwaitingStoreOpening': 'Mağaza Açılışı Bekleniyor',
        'Rejected': 'Reddedildi',
        'Completed': 'Tamamlandı'
      };
      const queryString = qs.stringify({
        page: filters.pageNumber,
        size: filters.pageSize,
        search: filters.search,
        startDate: filters.startDate ? moment(filters.startDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : filters.startDate,
        endDate: filters.endDate ? moment(filters.endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : filters.endDate,
        status: filters.status
      },
        {
          skipNulls: true,
          filter: (prefix, value) => (value !== '' ? value : undefined),
        });

      return axios
        .get(
          `/api/panel/company-application/company-list?${queryString}`
        )
        .then((response) => {
          response.data.payload.items.map((item) => {
            item.creationDate = moment(item.creationDate).format('DD/MM/YYYY')
            item.status = statusFilterItems[item.status]
          })
          commit("setMerchantList", response.data.payload.items);
          commit("setLoading", false);

          return response.data.payload;
        });
    },
    getMerchantApplicationDetails({ commit }, id) {
      commit("setLoading", true);

      return axios
        .get(
          `/api/panel/company-application/company-detail?id=${id}`
        )
        .then((response) => {
          commit("setMerchantDetails", response.data.payload);
          commit("setLoading", false);

          return response.data.payload;
        });
    },
    putAppliedMerchantStatus({ state }, payload) {
      return axios
        .put(`/api/panel/company-application/apply-company-application`, {
          id: payload.id,
          status: payload.status
        })
        .then((response) => {
          return response.data.payload
        })
        .catch((err) => {
          throw err;
        });
    },
    getMerchantApplicationDetailsByEmail({ commit, state }) {
      commit("setLoading", true);

      const email = localStorage.getItem('email')
      if (email) {
        return axios
          .get(
            `/api/panel/company-application/company-detail/${email}`
          )
          .then((response) => {
            commit("setLoading", false);
            return response.data.payload;
          });
      }
      return false
    },
    setMerchantApplicationDetails({ commit }, payload) {
      commit('setMerchantDetails', payload)
    },
    postSendOtp({ commit }, payload) {
      return axios
        .post(`/api/panel/company-application/send-mail-otp`, {
          email: payload.email,
          authorizedPerson: payload.authorizedPerson
        })
        .then((response) => {
          return response.data.payload
        })
        .catch((err) => {
          throw err;
        });
    },
    postConfirmOtp({ commit }, payload) {
      return axios
        .post(`/api/panel/company-application/confirm-mail-otp`, {
          email: payload.email,
          code: payload.code,
          etkContract: payload.etkContract
        })
        .then((response) => {
          return response.data.payload
        })
        .catch((err) => {
          throw err;
        });
    },
    getCheckByEmail({ commit }, email) {
      commit("setLoading", true);
      if (email) {
        return axios
          .get(
            `/api/panel/company-application/check-by-email/${email}`
          )
          .then((response) => {
            commit("setLoading", false);
            return response.data.payload;
          });
      }
      return false
    },
    exportMerchantApplications({ commit }, filters) {
      const queryString = qs.stringify({
        search: filters.search,
        startDate: filters.startDate ? moment(filters.startDate, 'DD-MM-YYYY').format('YYYY-MM-DDTHH:mm:ss') : filters.startDate,
        endDate: filters.endDate ? moment(filters.endDate, 'DD-MM-YYYY').format('YYYY-MM-DDTHH:mm:ss') : filters.endDate,
        status: filters.status
      },
        {
          skipNulls: true,
          filter: (prefix, value) => (value !== '' ? value : undefined),
        });

      axios({
        url: `/api/panel/company-application/export-company-list?${queryString}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Company-Applications-${new Date().toISOString().substr(0, 10)}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      });
    }
  },
  getters: {
    getFormData: (state) => () => state.formData,
    merchantList: (state) => state.merchantList,
    merchantDetails: (state) => state.merchantDetails
  },
};
